var map = {
	"./asset-hyperlink.json": 97885,
	"./blockquote.json": 64061,
	"./document.json": 18071,
	"./embedded-asset-block.json": 66241,
	"./embedded-entry-block.json": 16649,
	"./embedded-entry-inline.json": 38477,
	"./embedded-resource-block.json": 48119,
	"./embedded-resource-inline.json": 43703,
	"./entry-hyperlink.json": 41297,
	"./heading-1.json": 85018,
	"./heading-2.json": 26507,
	"./heading-3.json": 98920,
	"./heading-4.json": 12465,
	"./heading-5.json": 88470,
	"./heading-6.json": 34839,
	"./hr.json": 97828,
	"./hyperlink.json": 9156,
	"./list-item.json": 53110,
	"./ordered-list.json": 22658,
	"./paragraph.json": 91944,
	"./resource-hyperlink.json": 51313,
	"./table-cell.json": 94013,
	"./table-header-cell.json": 74599,
	"./table-row.json": 42247,
	"./table.json": 78234,
	"./text.json": 74957,
	"./unordered-list.json": 40133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4789;